import {connect} from 'react-redux';
import { fetchPages, fetchPagesSuccess, fetchPagesFailure } from '../../../actions/pages.js';
import FacebookConnect from  './FacebookConnect';

const mapDispatchToProps = (dispatch) => {
    return {
        fetchPages: () => {
            dispatch(fetchPages()).then((response) => {
                !response.error ? dispatch(fetchPagesSuccess(response.payload.data)) : dispatch(fetchPagesFailure(response.payload.data));
            });
        }
    }
}


export default connect(null, mapDispatchToProps)(FacebookConnect);


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FacebookConnect/FacebookConnectContainer.js